module.exports = __webpack_public_path__ + "static/media/call_add_member.0d3a12eb.svg";